export default class DataCache
{
    static myInstance = null;

    /**
     * DataCache is a singleton class
     */
    static getInstance()
    {
        if (DataCache.myInstance == null)
        {
            DataCache.myInstance = new DataCache();
        }
        return DataCache.myInstance;
    }

    _aData = {
        items: []
    };

    setItem = (aItem) =>
    {
        let nIdx = this._aData.items.findIndex((aItemExisting) =>
        {
            return aItemExisting.url === aItem.url;
        });
        if (0 > nIdx)
        {
            if (aItem.hasOwnProperty("url") && aItem.hasOwnProperty("response"))
            {
                this._aData.items.push(
                {
                    url: aItem.url,
                    response: aItem.response
                });
            }
        }
    }

    getItem = (sUrl) =>
    {
        let nIdx = this._aData.items.findIndex((aItem) =>
        {
            return aItem.url === sUrl;
        });
        if (0 > nIdx)
        {
            return null;
        }
        return this._aData.items[nIdx].response;
    }
}